/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`G-Force Calculator — RPM ⇄ RCF (Centrifuge) — Toolverse`)
};

const es_gf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Fuerza G — RPM ⇄ RCF (Centrífuga) — Toolverse`)
};

const de_gf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`G-Kraft-Rechner — RPM ⇄ RCF (Zentrifuge) — Toolverse`)
};

const nl_gf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`G-krachtcalculator — RPM ⇄ RCF (Centrifuge) — Toolverse`)
};

const fr_gf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de force g — RPM ⇄ RCF (Centrifugeuse) — Toolverse`)
};

const it_gf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore forza G — RPM ⇄ RCF (Centrifuga) — Toolverse`)
};

const pt_br2_gf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Força G — RPM ⇄ RCF (Centrífuga) — Toolverse`)
};

const pt_gf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Força G — RPM ⇄ RCF (Centrífuga) — Toolverse`)
};

const ja_gf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`遠心力計算機 — RPM ⇄ RCF(遠心分離機) — Toolverse`)
};

const zh_gf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`离心力计算器 — RPM ⇄ RCF（离心机） — Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gf_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gf_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gf_meta_title", locale)
	if (locale === "en") return en_gf_meta_title(inputs)
	if (locale === "es") return es_gf_meta_title(inputs)
	if (locale === "de") return de_gf_meta_title(inputs)
	if (locale === "nl") return nl_gf_meta_title(inputs)
	if (locale === "fr") return fr_gf_meta_title(inputs)
	if (locale === "it") return it_gf_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_gf_meta_title(inputs)
	if (locale === "pt") return pt_gf_meta_title(inputs)
	if (locale === "ja") return ja_gf_meta_title(inputs)
	return zh_gf_meta_title(inputs)
};